export interface TouchDirectionTracker {
	start(event: TouchEvent, touch: Touch): void;
	stop(): void;
}

export interface TouchDirectionTrackerConfig {
	onPullDown: (event: TouchEvent) => void;
}

// Pequeno tracker síncrono para discernir a intenção do gesto de toque no primeiro pixel.
// Isola o gerenciamento de listeners temporários de touchmove/touchend/touchcancel.
export function createTouchDirectionTracker(
	config: TouchDirectionTrackerConfig
): TouchDirectionTracker {
	let startY = 0;
	let startX = 0;
	let startEvent: TouchEvent | null = null;
	let isActive = false;

	function onTouchMove(event: TouchEvent): void {
		if (!startEvent) {
			stop();
			return;
		}
		const touch = event.touches[0];
		if (!touch) return;

		const dy = touch.clientY - startY;
		const dx = touch.clientX - startX;

		// No primeiro pixel de movimento decidimos se é pull-down (arrastar para baixo)
		if (dy > 0 && Math.abs(dy) >= Math.abs(dx)) {
			if (event.cancelable) event.preventDefault();
			const originalEvent = startEvent;
			stop();
			config.onPullDown(originalEvent);
		} else if (Math.max(Math.abs(dy), Math.abs(dx)) >= 3) {
			// Scroll de leitura (para cima) ou horizontal detectado: libera o scroll nativo
			stop();
		}
	}

	function start(event: TouchEvent, touch: Touch): void {
		if (isActive || !import.meta.client) return;
		startY = touch.clientY;
		startX = touch.clientX;
		startEvent = event;
		isActive = true;

		window.addEventListener('touchmove', onTouchMove, { passive: false });
		window.addEventListener('touchend', stop, { passive: true });
		window.addEventListener('touchcancel', stop, { passive: true });
	}

	function stop(): void {
		if (!isActive || !import.meta.client) return;
		window.removeEventListener('touchmove', onTouchMove);
		window.removeEventListener('touchend', stop);
		window.removeEventListener('touchcancel', stop);

		startY = 0;
		startX = 0;
		startEvent = null;
		isActive = false;
	}

	return { start, stop };
}
